export default {"src":"/_next/static/media/WhoWeAre_020A.7a6bf5d8.JPG","height":688,"width":1920};